var pg_sliders = [];
var cta3_products_sliders = [];
var related_products_sliders = [];
var compare_products_sliders = [];
var bfresh3_products_sliders = [];
var howto_use_slider = null;

jQuery(document).ready(function($) {
  initSearchBar();
  initQuantityFocus();
  initProductsGridSliders();
  initCTA3ProductsSlider();
  initRelatedProductsSlider();
  initCompareProductsSlider();
  initHowtoUseSlider();
  initBfresh3ProductsSlider();

  $(window).resize(function () {
    initProductsGridSliders();
    initCTA3ProductsSlider();
    initRelatedProductsSlider();
    initCompareProductsSlider();
    initHowtoUseSlider();
    initBfresh3ProductsSlider();
  });

  $(document).on("click", ".products-grid .grid-item .inner, .products-grid-hold .item .hold, .btan-cta-3-products .product .hold", function(e) {
    if ($(e.target).closest('button, a, input, select, textarea, label').length) return;
    e.preventDefault();
    let link = $(this).find('a').attr('href'); 
    if (link) {
      window.location = link;
    }
  });

  function rgb2hex(rgb) {
     if (  rgb.search("rgb") == -1 ) {
          return rgb;
     } else {
          rgb = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/);
          function hex(x) {
               return ("0" + parseInt(x).toString(16)).slice(-2);
          }
          return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]); 
     }
  }
  // Calculate a darker end_color based on start_color
  function darkenColor(color, percent) {
    let rgb;
    if (color.startsWith('#')) {
      // Convert hex to RGB
      let hex = color.replace('#', '');
      if (hex.length === 3) {
        hex = hex.split('').map(x => x + x).join('');
      }
      let r = parseInt(hex.substring(0,2), 16);
      let g = parseInt(hex.substring(2,4), 16);
      let b = parseInt(hex.substring(4,6), 16);
      rgb = [r, g, b];
    } else {
      rgb = color.match(/\d+/g);
      if (!rgb) return color;
      rgb = rgb.map(Number);
    }
    let r = Math.max(0, Math.floor(rgb[0] * (1 - percent)));
    let g = Math.max(0, Math.floor(rgb[1] * (1 - percent)));
    let b = Math.max(0, Math.floor(rgb[2] * (1 - percent)));
    return `rgb(${r}, ${g}, ${b})`;
  }
  // Change hover color to linear gradient for product figures
  $(document).on('mouseenter', '.btan-cta-3-products .row .column-products .products .product .hold', function() {
    let start_color = rgb2hex($(this).css('backgroundColor'));
    let end_color = darkenColor(start_color, 0.25); // 25% darker
    $(this).parent().find('.hover-layer').css('background', 'linear-gradient(180deg, '+start_color+' 0%, '+end_color+' 100%)');
  });
  $(document).on('mouseleave', '.btan-cta-3-products .row .column-products .products .product .hold', function() {
    $(this).parent().find('.hover-layer').css('background', '');
  });

  if($('.main-product-slider').length > 0) {
    tns({
      container: $('.main-product-slider')[0],
      items: 1.15,
      edgePadding: 20,
      slideBy: 1, 
      controls: false,
      nav: true,
      autoplayButtonOutput: false, 
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 5000,
      lazyload: true, 
      mouseDrag: true, 
      navPosition: 'bottom',
      gutter: 20,
      loop: true,
      rewind: false,
      swipeAngle: 40,
      navContainer: $('.product-photo-container .slider-nav .dots')[0],
      prevButton: $('.product-photo-container .slider-nav .prev')[0],
      nextButton: $('.product-photo-container .slider-nav .next')[0],
      responsive: {
        1024: {
          items: 2.1,
          edgePadding: 158,
          gutter: 40,
        },
        768: {
          items: 2.1,
          controls: true,
        }, 
      }
    }); 
  }

  function initSearchBar() {
    $(".nav-search .search-bar .input-group-field").bind(
      "focusin",
      function () {
        $(this).closest(".nav-search").addClass("focused");
      }
    );
    $(".nav-search .search-bar .input-group-field").bind(
      "focusout",
      function () {
        $(this).closest(".nav-search").removeClass("focused");
      }
    );
  }

  function initQuantityFocus() {
    $("#quantity").bind("focusin", function () {
      $(this).closest(".quantity--contain").addClass("focused");
    });
    $("#quantity").bind("focusout", function () {
      $(this).closest(".quantity--contain").removeClass("focused");
    });
  }

  function initProductsGridSliders() {
    if( $(".section-btan-products-grid .products-grid-hold").length === 0) return;

    var $container = $("main.btan-main").length > 0 ? $("main.btan-main") : $("main.bfresh-main");
    if ($container.innerWidth() > 1023) {
      if (pg_sliders.length > 0) {
        for (var i in pg_sliders) {
          pg_sliders[i].destroy();
        }
        pg_sliders = [];
      }
    } else {
      if (pg_sliders.length == 0) {
        $(".section-btan-products-grid .products-grid-hold").each(function () {
          var slider = tns({
            container: $(this)[0],
            items: 2,
            nav: false,
            controls: false,
            gutter: 3,
            center: false,
            loop: true,
            edgePadding: 20,
            autoplayButtonOutput: false, 
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 5000,
            responsive: {
              768: {
                items: 3, 
                edgePadding: 0,
              },
              480: { 
                gutter: 14,
              }
            }
          });
          pg_sliders.push(slider);
        });
      }
    }
  }

  function initCTA3ProductsSlider() {
    var $container = $(".btan-cta-3-products-hold");
    var $slider = $container.find(".products");
    if ($container.innerWidth() > 767) {
      if (cta3_products_sliders.length > 0) {
        for (var i in cta3_products_sliders) {
          cta3_products_sliders[i].destroy();
        }
        cta3_products_sliders = [];
      }
    } else {
      if (cta3_products_sliders.length == 0) {
        $slider.each(function () {
          var slider = tns({
            container: $(this)[0],
            items: 2.2,
            nav: false,
            controls: false,
            gutter: 14,
            center: false,
            loop: true,
            edgePadding: 20,
            autoplayButtonOutput: false, 
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 5000,
          });
          cta3_products_sliders.push(slider);
        });
      }
    }
  }
  
  function initRelatedProductsSlider() {
    if ($(".related-products .products-grid").length === 0) return; 

    var $container = $(".related-products");
    var $slider = $container.find(".products-grid");
    if ($container.innerWidth() > 767) {
      if (related_products_sliders.length > 0) {
        for (var i in related_products_sliders) {
          related_products_sliders[i].destroy();
        }
        related_products_sliders = [];
      }
    }
    else {
      if (related_products_sliders.length == 0) {
        $slider.each(function () {
          var slider = tns({
            container: $(this)[0],
            items: 2,
            nav: false,
            controls: false,
            gutter: 14,
            center: false,
            loop: true,
            edgePadding: 20, 
            autoplayButtonOutput: false, 
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 5000,
          });
          related_products_sliders.push(slider);
        });
      }
    }
  }

  function initCompareProductsSlider() {
    if ($(".btan-compare-table .compare-slider").length === 0) return; 

    var $container = $(".btan-compare-table");
    var $slider = $container.find(".compare-slider");
    var breakpoint = 767; // Define the breakpoint for mobile view
    if($container.find('.pseudo-table').hasClass('num-4')) {
      breakpoint = 1023; // Adjust breakpoint for 4 columns
    }
    if ($container.innerWidth() > breakpoint) {
      if (compare_products_sliders.length > 0) {
        for (var i in compare_products_sliders) {
          compare_products_sliders[i].destroy();
        }
        compare_products_sliders = [];
      }
    }
    else {
      if (compare_products_sliders.length == 0) {
        $slider.each(function () {
          var slider = tns({
            container: $(this)[0],
            items: 2.2,
            nav: false,
            controls: false,
            gutter: 0,
            center: false,
            loop: false,
            edgePadding: 20, 
            mouseDrag: true,
            autoplayButtonOutput: false, 
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 5000,
            responsive: {
              768: {
                items: 3.2,
              }
            }
          });
          compare_products_sliders.push(slider);
        });
      }
    }
  }

  function initHowtoUseSlider() {
    if ($(".btan-how-to-use .list").length === 0) return; 

    var $container = $(".btan-info-tabs__hold");
    var $slider = $container.find(".btan-how-to-use .list");
    if ($container.innerWidth() >= 600) {
      if (howto_use_slider != null) { 
        howto_use_slider.destroy(); 
        howto_use_slider = null;
      }
    }
    else {
      if (howto_use_slider == null) {
        $slider.each(function () {
          howto_use_slider = tns({
            container: $(this)[0],
            items: 1.2,
            nav: false,
            controls: false,
            gutter: 14,
            center: false,
            loop: true,
            edgePadding: 20, 
            autoplayButtonOutput: false, 
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 5000,
            responsive: {
              480: {
                items: 2.2, 
              }, 
            }
          }); 
        });
      }
    }
  }

  function initBfresh3ProductsSlider() {
    if ($(".bfresh-3-products-hold .products").length === 0) return;

    var $container = $(".bfresh-3-products-hold .products");
    if ($container.innerWidth() > 639) {
      if (bfresh3_products_sliders.length > 0) {
        for (var i in bfresh3_products_sliders) {
          bfresh3_products_sliders[i].destroy();
        }
        bfresh3_products_sliders = [];
      }
    } else {
      if (bfresh3_products_sliders.length == 0) {
        $container.each(function () {
          var slider = tns({
            container: $(this)[0],
            items: 2.2,
            nav: false,
            controls: false,
            gutter: 14,
            center: false,
            loop: true,
            edgePadding: 20, 
            autoplayButtonOutput: false, 
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 5000,
          });
          bfresh3_products_sliders.push(slider);
        });
      }
    }
  }
});